export { default } from './MasterSection';
